import type { ExecutionResponse } from '@/shared/api/execution';
import type { Library } from '@/shared/types';

type ExecutionWithInstalledLibraries = ExecutionResponse & {
  installedLibraries?: Library[] | null;
};

export const getInstalledLibrariesFromExecution = (
  execution: ExecutionResponse | null | undefined,
  files: Record<string, string>
): Library[] | null => {
  const installedLibraries = (execution as ExecutionWithInstalledLibraries | null | undefined)?.installedLibraries;

  if (!Array.isArray(installedLibraries) || installedLibraries.length === 0) {
    return null;
  }

  return installedLibraries.map((library) => {
    if (library.type === 'custom') {
      const filename = `${library.name}.py`;
      return {
        name: library.name,
        type: 'custom',
        content: files[filename] ?? library.content ?? '',
      };
    }

    return {
      name: library.name,
      type: 'standard',
    };
  });
};
